var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileGradient({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4314_130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8335 19.7975V22.4383C26.8402 23.3446 26.5509 24.2292 26.0077 24.9629C25.4645 25.6965 24.6961 26.2408 23.8146 26.5162C20.64 27.5002 17.33 28.0007 14.0003 28C10.6948 27.9996 7.40867 27.5062 4.2548 26.5369C3.36034 26.267 2.5778 25.7232 2.02204 24.9856C1.46629 24.2479 1.16661 23.3551 1.16699 22.4383V19.7975C1.16742 18.9047 1.45245 18.0343 1.98229 17.3079C2.51213 16.5815 3.26032 16.0352 4.1224 15.7455C5.27896 15.3504 6.40327 14.87 7.48567 14.3084C7.9246 14.0863 8.41533 13.981 8.90884 14.0028C9.40236 14.0247 9.88138 14.173 10.2981 14.4329C11.3993 15.1365 12.6856 15.5111 14.0003 15.5111C15.315 15.5111 16.6013 15.1365 17.7025 14.4329C18.1192 14.173 18.5982 14.0247 19.0918 14.0028C19.5853 13.981 20.076 14.0864 20.5149 14.3084C21.5978 14.8691 22.722 15.3495 23.8782 15.7455C24.7408 16.0344 25.4896 16.5804 26.0196 17.307C26.5495 18.0336 26.8342 18.9045 26.8335 19.7975Z",
    fill: "url(#paint0_linear_4314_130)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.20181 5.55467C7.60801 0.543369 14.7575 -1.86217 18.412 1.69251C18.9338 2.21296 19.3272 2.82587 19.5665 3.4913C19.8057 4.15674 19.8856 4.85979 19.8008 5.55467L19.5312 7.74281C19.2311 10.1994 16.9367 12.8333 14.0013 12.8333C11.0659 12.8333 8.77158 10.1994 8.47145 7.74281L8.20181 5.55467Z",
    fill: "url(#paint1_linear_4314_130)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4314_130",
    x1: -3.14644,
    y1: 58.1,
    x2: -29.0381,
    y2: 38.0843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E827D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4314_130",
    x1: -3.14644,
    y1: 58.1,
    x2: -29.0381,
    y2: 38.0843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E827D9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4314_130"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileGradient);
export default __webpack_public_path__ + "static/media/profile_gradient.6384b0b99f7b339714e6db25fa1e87ef.svg";
export { ForwardRef as ReactComponent };